export default __webpack_public_path__ + "static/media/chat3.0bc0146a.jpg";